import 'react-app-polyfill/stable'
import 'core-js'
import React from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'
import reportWebVitals from './reportWebVitals'
import { Provider } from 'react-redux'
import store from './store'
import { LicenseManager } from 'ag-grid-enterprise'
import { Auth0Provider } from '@auth0/auth0-react'

LicenseManager.setLicenseKey(
  'CompanyName=Flexible Staffing Services,LicensedGroup=Flexible Staffing Services,LicenseType=MultipleApplications,LicensedConcurrentDeveloperCount=1,LicensedProductionInstancesCount=0,AssetReference=AG-033177,SupportServicesEnd=22_September_2023_[v2]_MTY5NTMzNzIwMDAwMA==891dfb8f3b0f44fb648a8320cfc96e1c',
)

const container = document.getElementById('root')
const root = createRoot(container)
root.render(
  <Auth0Provider
    domain={process.env.REACT_APP_AUTH0_CLIENT_DOMAIN}
    clientId={process.env.REACT_APP_AUTH0_CLIENT_ID}
    redirectUri={window.location.origin}
  >
    <Provider store={store}>
      <App />
    </Provider>
  </Auth0Provider>,
  document.getElementById('root'),
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
